import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { PopularCard } from './types';

const MAX_POPULAR_CARDS = 5;

const updatePopularCards = (customerId: string, cardId: string, popularCards?: GenericObject) => {
  const foundCardId = popularCards?.[customerId]?.find((card: PopularCard) => card.cardId === cardId);

  if (foundCardId) {
    return {
      ...popularCards,
      [customerId]: (popularCards?.[customerId] as PopularCard[])
        .map(card => ({
          ...card,
          viewsCount: card.cardId === cardId ? card.viewsCount + 1 : card.viewsCount,
        }))
        .sort((a, b) => b.viewsCount - a.viewsCount),
    };
  }
  return {
    ...popularCards,
    [customerId]: [...(popularCards?.[customerId] || []), { cardId, viewsCount: 1 }].sort(
      (a, b) => b.viewsCount - a.viewsCount,
    ),
  };
};

const formatExpirationDate = (value: string) => {
  const date = new Date(value);
  const year = String(date.getFullYear()).substring(2, 4);
  return `**/${year}`;
};

const constructAddress = (val: {
  address?: string;
  zipCode?: string;
  city?: string;
  state?: string;
  country?: string;
}) => {
  let addressValue = '';

  if (val.address) {
    addressValue = `${val.address},`;
  }

  if (val.zipCode) {
    addressValue = `${addressValue} ${val.zipCode},`;
  }

  if (val.city) {
    addressValue = `${addressValue} ${val.city},`;
  }

  if (val.state) {
    addressValue = `${addressValue} ${val.state},`;
  }

  if (val.country) {
    addressValue = `${addressValue} ${val.country}`;
  }

  return addressValue;
};

export { MAX_POPULAR_CARDS, updatePopularCards, formatExpirationDate, constructAddress };
